<!-- ═══════════════════════════════════════════════════════
     TOAST & CONFIRM DIALOGS (sin cambios funcionales)
═══════════════════════════════════════════════════════ -->
<p-toast position="top-right" key="msj"></p-toast>

<p-confirmDialog
  [style]="{ width: '50vw' }"
  key="sinInformacionDialog"
  [baseZIndex]="10000"
  acceptLabel="Aceptar"
  rejectLabel="Cancelar"
  rejectButtonStyleClass="p-button-text"
  styleClass="erp-dialog"
  [rejectVisible]="false">
</p-confirmDialog>

<p-confirmDialog
  [style]="{ width: '50vw' }"
  key="kc"
  [baseZIndex]="10000"
  acceptLabel="SI"
  rejectLabel="NO"
  rejectButtonStyleClass="p-button-outlined">
</p-confirmDialog>

<!-- ═══════════════════════════════════════════════════════
     PÁGINA PRINCIPAL
═══════════════════════════════════════════════════════ -->
<div class="min-h-screen bg-[#F2F2F2] p-2 ml:p-4 font-sans">

  <!-- ── CARD PRINCIPAL ── -->
  <div class="bg-white rounded-2xl shadow-lg overflow-hidden">

    <!-- ── HEADER ── -->
    <div class="bg-[#6588A6] px-6 py-5 md:px-8">
      <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-4">

        <!-- Título -->
        <div class="flex items-center gap-4">
          <div class="flex-shrink-0 w-6 h-12 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm">
            <i class="pi pi-history text-white text-2xl"></i>
          </div>
          <div>
            <!-- <p class="text-[#C4D9EC] text-xs font-semibold uppercase tracking-widest">Módulo</p> -->
            <h1 class="text-white text-xl xl:text-4xl font-bold leading-tight">
              Operación Diaria
              <span class="text-[#C4D9EC] font-normal">— Servicios Adicionales</span>
            </h1>
          </div>
        </div>

        <!-- Filtro de Fecha -->
        <div class="flex flex-col sm:flex-row items-stretch sm:items-end gap-3">
          <div class="flex flex-col gap-1">
            <label class="text-[#C4D9EC] text-xs font-semibold uppercase tracking-wider flex items-center gap-1">
              <i class="pi pi-calendar text-sm"></i> Fecha
            </label>
            <input
              type="date"
              class="bg-white/15 border border-white/30 text-white rounded-lg px-3 py-2 text-sm
                     placeholder-indigo-200 focus:outline-none focus:ring-2 focus:ring-[#C4D9EC]/60
                     [color-scheme:dark] min-w-[160px]"
              pTooltip="Seleccione o teclee fecha"
              tooltipPosition="top"
              [(ngModel)]="fecha_dia">
          </div>

          <button pButton pRipple type="button"
            (click)="cargarInformacionPorFecha(fecha_dia,'1900-01-01')"
            class="!bg-white !text-[#6588A6] !border-0 !rounded-lg !font-semibold !px-5 !py-2
                   hover:!bg-[#EBF2F8] !transition-all !shadow-sm flex items-center gap-2">
            <i class="pi pi-filter"></i> Filtrar
          </button>

          <button *ngIf="mostrarbtnLimpiarFiltro"
            pButton pRipple type="button"
            (click)="LimpiarFiltro()"
            pTooltip="Reiniciar Filtro" tooltipPosition="top"
            class="!bg-[#B8956B] !text-white !border-0 !rounded-lg !font-semibold !px-4 !py-2
                   hover:!bg-[#A07D55] !transition-all flex items-center gap-2">
            <i class="pi pi-filter-slash"></i> Limpiar
          </button>
        </div>

      </div>
    </div>
    <!-- /HEADER -->

    <!-- ── BARRA DE ACCIONES (fuera de la tabla) ── -->
    <!-- <div class="px-4 md:px-6 pt-5 pb-3 border-b border-slate-100">
      <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">

        
        <div class="flex items-center gap-2">
          <div class="w-1 h-5 rounded-full bg-[#82B0D9]"></div>
        </div>

        
        <div class="flex items-center gap-2 sm:justify-end">

            <button type="button" pButton pRipple
            (click)="abrirModalReportes()"
            pTooltip="Abrir ventana de reportes" tooltipPosition="left"
            class="!bg-white !border !border-[#C4D9EC] !text-[#4A6480] !rounded-lg !font-semibold
                   !px-4 !py-2 hover:!bg-[#EBF2F8] hover:!border-[#82B0D9] !transition-all !shadow-sm
                   flex items-center gap-2 !text-sm">
            <i class="pi pi-chart-bar text-[#B8956B] text-base"></i>
            <span>Reportes</span>
          </button>

        </div>
      </div>
    </div> -->

    <!-- ── TABLA ── -->
    <div class="px-4 md:px-6 pb-4 md:pb-6">
      <p-table
        #dt1
        [value]="lstMovimientos"
        [scrollable]="true"
        scrollHeight="flex"
        scrollDirection="both"
        [paginator]="true"
        [rows]="50"
        [rowsPerPageOptions]="[100,150,200,250,300]"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="{first} a {last} de {totalRecords} registros"
        [globalFilterFields]="['desc_folio','desc_ruta','num_economico','nombre_chofer','nombre_completo_adicional1','nombre_completo_adicional2']"
        [loading]="loading"
        styleClass="erp-table">

       <!-- ── CAPTION — solo búsqueda + filtros ── -->
        <ng-template pTemplate="caption">
        <div class="flex flex-col gap-3 py-1">
             <!-- Buscador global -->
            <div class="flex sm:justify-end">
            <div class="relative flex-shrink-0">
                <i class="pi pi-search absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-xs"></i>
                <input pInputText type="text"
                (input)="applyFilterGlobal($event, 'contains')"
                placeholder="Buscar chofer o # económico…"
                pTooltip="Buscar chofer, # económico, folio"
                class="!pl-8 !pr-4 !py-1.5 !rounded-lg !border !border-slate-200 !text-xs
                        !bg-slate-50 focus:!ring-2 focus:!ring-[#82B0D9] !transition-all !w-64" />
            </div>
            </div>
            <!-- Acordeón de filtros -->
            <p-accordion styleClass="erp-accordion">
            <p-accordionTab>
                <ng-template pTemplate="header">
                <span class="flex items-center gap-2 text-xs font-bold text-slate-600 uppercase tracking-wider">
                    <i class="pi pi-filter text-[#6588A6]"></i> Filtros
                </span>
                </ng-template>
                <ng-template pTemplate="content">
                <div class="flex flex-wrap gap-2 py-2">
                    <p-columnFilter type="text" field="desc_ruta" placeholder="Ruta"
                    class="!rounded-lg !border !border-slate-200 !text-xs !bg-slate-50 !px-2 !py-1.5 !w-100"
                    matchMode="contains">
                    </p-columnFilter>

                    <p-columnFilter type="text" field="desc_cliente" placeholder="Cliente"
                    class="!rounded-lg !border !border-slate-200 !text-xs !bg-slate-50 !px-2 !py-1.5 !w-70"
                    matchMode="contains">
                    </p-columnFilter>

                    <p-columnFilter type="text" field="desc_proyecto" placeholder="Proyecto"
                    class="!rounded-lg !border !border-slate-200 !text-xs !bg-slate-50 !px-2 !py-1.5 !w-50"
                    matchMode="contains">
                    </p-columnFilter>

                    <p-columnFilter type="text" field="desc_ciudad" placeholder="Ciudad"
                    class="!rounded-lg !border !border-slate-200 !text-xs !bg-slate-50 !px-2 !py-1.5 !w-50"
                    matchMode="contains">
                    </p-columnFilter>
                </div>
                </ng-template>
            </p-accordionTab>
            </p-accordion>
        </div>
        </ng-template>

        <!-- ── HEADER DE TABLA ── -->
        <ng-template pTemplate="header">
          <tr>
            <!-- <th class="w-1 px-4 py-3 bg-[#2E4357] text-[#A8C4D8] text-xs font-semibold uppercase tracking-wider text-center rounded-tl-lg">#</th> -->
            <th class="min-w-[200px] px-4 py-3 bg-[#2E4357] text-[#A8C4D8] text-xs font-semibold uppercase tracking-wider rounded-tl-lg"
                pSortableColumn="desc_ruta">
              <span class="flex items-center gap-1">Ruta <p-sortIcon field="desc_ruta"></p-sortIcon></span>
            </th>
            <th class="min-w-[200px] px-4 py-3 bg-[#2E4357] text-[#A8C4D8] text-xs font-semibold uppercase tracking-wider"
                pSortableColumn="   ">
              <span class="flex items-center gap-1">Tipo de Ruta <p-sortIcon field="desc_tiporuta"></p-sortIcon></span>
            </th>
            <th class="min-w-[140px] px-4 py-3 bg-[#2E4357] text-[#A8C4D8] text-xs font-semibold uppercase tracking-wider">Ciudad</th>
            <th class="min-w-[110px] px-4 py-3 bg-[#2E4357] text-[#A8C4D8] text-xs font-semibold uppercase tracking-wider"
                pSortableColumn="num_economico">
              <span class="flex items-center gap-1"># Económico <p-sortIcon field="num_economico"></p-sortIcon></span>
            </th>
            <th class="min-w-[220px] px-4 py-3 bg-[#2E4357] text-[#A8C4D8] text-xs font-semibold uppercase tracking-wider">Colaboradores</th>
            <th class="min-w-[120px] px-4 py-3 bg-[#2E4357] text-[#A8C4D8] text-xs font-semibold uppercase tracking-wider">Fecha / Hora</th>
            <th class="min-w-[130px] px-4 py-3 bg-[#2E4357] text-[#A8C4D8] text-xs font-semibold uppercase tracking-wider text-center">Servicios</th>
            <!-- <th class="min-w-[140px] px-4 py-3 bg-[#2E4357] text-[#A8C4D8] text-xs font-semibold uppercase tracking-wider text-center rounded-tr-lg">Extensiones</th> -->
          </tr>
        </ng-template>

        <!-- ── BODY DE TABLA ── -->
        <ng-template pTemplate="body" let-data let-rowIndex="rowIndex">
          <tr class="border-b border-slate-100 hover:bg-[#EBF2F8]/60 transition-colors text-sm"
              [ngClass]="{ 'bg-red-50': data.clv_especial == 1 }">

            <!-- # -->
            <!-- <td class="px-4 py-3 text-slate-400 font-mono text-xs">{{ rowIndex + 1 }}</td> -->

            <!-- Ruta -->
            <td class="px-4 py-3">
              <span class="font-semibold text-slate-800"
                    [ngClass]="{ 'text-[#B85C5C]': data.clv_especial == 1 }">
                {{ data.desc_ruta }}
              </span>
              <span class="ml-1 text-lime-600 font-bold text-xs">{{ data.desc_folio }}</span>
            </td>

            <!-- Tipo de Ruta -->
            <td class="px-4 py-3">
              <span [ngClass]="{ 'text-[#B85C5C] font-semibold': data.clv_especial == 1 }">
                {{ data.desc_tiporuta }}
              </span>
              <span *ngIf="data.clv_cancelado == 1"
                class="ml-2 inline-flex items-center px-2 py-0.5 rounded-full text-xs
                       font-bold bg-orange-100 text-orange-600"
                pTooltip="La ruta se marcó como Cancelada por Operaciones">
                CANCELADA
              </span>
            </td>

            <!-- Ciudad -->
            <td class="px-4 py-3 text-slate-600">{{ data.desc_ciudad }}</td>

            <!-- # Económico -->
            <td class="px-4 py-3">
              <span class="inline-flex items-center px-2.5 py-1 rounded-lg bg-[#EBF2F8]
                           text-amber-600 font-bold text-xs border border-[#C4D9EC]">
                {{ data.num_economico }}
              </span>
            </td>

            <!-- Colaboradores -->
            <td class="px-4 py-3">
              <div class="flex flex-col gap-1">
                <span class="inline-flex items-center gap-1 text-xs">
                  <span class="w-2 h-2 rounded-full bg-[#82B0D9] flex-shrink-0"></span>
                  <span class="text-[#2E4357] font-semibold">{{ data.nombre_chofer }}</span>
                </span>
                <div *ngIf="data.cod_adicional1 != 0">
                    <span  class="inline-flex items-center gap-1 text-xs">
                    <span class="w-2 h-2 rounded-full bg-[#6588A6] flex-shrink-0"></span>
                    <span class="text-[#4A6480]">{{ data.desc_puesto_adicional1 }} — {{ data.nombre_completo_adicional1 }}</span>
                    </span>
                </div>
                <div *ngIf="data.cod_adicional2 != 0">
                    <span *ngIf="data.id_puesto2 != 0" class="inline-flex items-center gap-1 text-xs">
                    <span class="w-2 h-2 rounded-full bg-[#82B0D9] flex-shrink-0"></span>
                    <span class="text-[#6588A6]">{{ data.desc_puesto_adicional2 }} — {{ data.nombre_completo_adicional2 }}</span>
                    </span>
                </div>
              </div>
            </td>

            <!-- Fecha / Hora -->
            <td class="px-4 py-3">
              <div class="flex flex-col gap-0.5">
                <span class="text-slate-700 font-medium text-xs">
                  {{ data.fecha_registro | date: 'dd/MM/yyyy' }}
                </span>
                <span class="text-[#6588A6] font-bold text-xs">{{ data.hora }}</span>
              </div>
            </td>

            <!-- Botón Servicios -->
             <td class="px-4 py-3 text-center">
                <button type="button" pButton pRipple
                    (click)="abrirModalViajeVacio(data)"
                    class="!bg-[#6588A6] !border-0 !rounded-lg !text-white !font-semibold
                        !px-4 !py-2 hover:!bg-[#4A6480] !transition-all !shadow-sm
                        flex items-center gap-2 !text-sm mx-auto">
                    <i class="pi pi-truck text-base"></i>
                    <span>Viaje Vacío</span>
                </button>
            </td>
            <!-- <td class="px-4 py-3 text-center">
              <p-splitButton
                label="Servicios"
                icon="pi pi-home"
                [model]="items"
                [appendTo]="'body'"
                (onDropdownClick)="SeleccionExtension(data)"
                styleClass="erp-split-primary">
              </p-splitButton>
            </td> -->

            <!-- Botón Extensiones -->
            <!-- <td class="px-4 py-3 text-center">
              <p-splitButton
                label="Extensiones"
                icon="pi pi-plus"
                [model]="itemsExtra"
                [appendTo]="'body'"
                [disabled]="data.clv_finalizado == 0"
                (onDropdownClick)="SeleccionExtension(data)"
                styleClass="erp-split-warning">
              </p-splitButton>
              <p *ngIf="data.clv_finalizado == 0"
                class="mt-1 text-center text-red-500 font-semibold leading-tight"
                style="font-size: 9px;">
                *Sin finalizar por Operaciones/Combustible
              </p>
            </td> -->

          </tr>
        </ng-template>

      </p-table>
    </div>
    <!-- /TABLA -->

  </div>
  <!-- /CARD PRINCIPAL -->
  <!-- ════════════════════════════════════════════════════
     MODAL — VIAJE VACÍO
════════════════════════════════════════════════════ -->
<p-dialog [resizable]="false" [draggable]="false"
  [(visible)]="dspViajeVacio"
  [style]="{ 'min-width': '35vw','width':'50vw', 'height': 'auto' }"
  [transitionOptions]="'0ms'"
  styleClass="erp-dialog"
  (onHide)="cancelarModalViajeVacio()">

  <ng-template pTemplate="header">
    <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
      <div class="flex-shrink-0 w-6 h-12 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm">
        <i class="pi pi-send text-white"></i>
      </div>
      <div>
        <h4 class="text-white text-base md:text-2xl font-bold leading-tight whitespace-nowrap">Viaje Vacío</h4>
        <p class="text-slate-400 text-xs text-white font-bold">{{ fecha_dia | date: 'dd/MM/yyyy' }}</p>
      </div>
    </div>
      
        <div class="flex flex-col sm:flex-row md:justify-end gap-3">
            <button type="button" pButton pRipple
                *ngIf="this.selectedMovimiento.clv_eliminar==1"
                (click)="eraseViajeVacio()"
                pTooltip="Eliminar" tooltipPosition="left"
                class="!bg-[#B85C5C] !border !border-[#C4D9EC] !text-white !rounded-lg !font-semibold
                    !px-4 !py-2 hover:!bg-red-900 hover:!border-[#82B0D9] !transition-all !shadow-sm
                    flex gap-2 !text-sm">
                <i class="pi pi-trash text-white text-base"></i>
            </button>
            <button 
                class="dialog-close-btn"
                type="button"
                (click)="dspViajeVacio = false"
                aria-label="Cerrar">
                <i class="pi pi-times"></i>
            </button>
            
        </div> 
        <!-- <div class="flex items-center gap-2 sm:justify-end">
            
        </div>        -->
    <!-- </div> -->
  </ng-template>
  

  <ng-template pTemplate="content">
    <div class="p-4 md:p-6">
      <form [formGroup]="viajeVacioForm">
        <div class="space-y-3">
        <!-- <div class="px-4 md:px-6 pt-5 pb-3 border-b border-slate-100">
            <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                <div class="flex items-center gap-2">
                <div class="w-1 h-5 rounded-full bg-[#82B0D9]"></div>
                </div>
                <div class="flex items-center gap-2 sm:justify-end" *ngIf="this.selectedMovimiento.clv_eliminar==1">
                    <button type="button" pButton pRipple
                        (click)="eraseViajeVacio()"
                        pTooltip="Eliminar" tooltipPosition="left"
                        class="!bg-[#B85C5C] !border !border-[#C4D9EC] !text-white !rounded-lg !font-semibold
                            !px-4 !py-2 hover:!bg-red-900 hover:!border-[#82B0D9] !transition-all !shadow-sm
                            flex items-center gap-2 !text-sm">
                        <i class="pi pi-trash text-white text-base"></i>
                        <span>Eliminar</span>
                    </button>
                </div>
            </div>
        </div> -->
            <div class="flex items-start gap-2 bg-[#EBF2F8] rounded-lg p-3" *ngIf="this.selectedMovimiento.clv_eliminar==1">
                <i class="pi pi-info-circle text-[#82B0D9] mt-0.5 flex-shrink-0 text-sm"></i>
                <div class="text-xs text-[#6588A6] space-y-1">
            
                <p class="text-orange-600 font-semibold flex items-center gap-1 pt-1">
                    <i class="pi pi-exclamation-triangle text-xs"></i>
                    Este servicio de ruta ya cuenta con un servicio de viaje vacio.
                </p>
                </div>
            </div>
          <!-- Origen -->
          <div class="space-y-1">
            <label class="text-sm font-semibold text-slate-600 flex items-center gap-1">
              <i class="pi pi-map-marker text-[#82B0D9] text-xs"></i> Origen (Ciudad, Estado)
            </label>
            <input type="text"
              formControlName="origen"
              placeholder="Ej: Culiacán, Sinaloa"
              class="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm
                     focus:outline-none focus:ring-2 focus:ring-[#82B0D9] transition-all bg-white
                     placeholder:text-slate-300">
          </div>

          <!-- Destino -->
          <div class="space-y-1">
            <label class="text-sm font-semibold text-slate-600 flex items-center gap-1">
              <i class="pi pi-map-marker text-[#6588A6] text-xs"></i> Destino (Ciudad, Estado)
            </label>
            <input type="text"
              formControlName="destino"
              placeholder="Ej: Guadalajara, Jalisco"
              class="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm
                     focus:outline-none focus:ring-2 focus:ring-[#82B0D9] transition-all bg-white
                     placeholder:text-slate-300">
          </div>

          <!-- Botón Calcular KM -->
          <div class="flex justify-center pt-1">
            <button type="button"
              (click)="calcularKM()"
              [disabled]="!viajeVacioForm.get('origen')?.value || !viajeVacioForm.get('destino')?.value 
                || (calculandoKM && this.selectedMovimiento.clv_eliminar==1)"
              pTooltip="Calcular kilómetros vía Google Maps" tooltipPosition="top"
              class="px-6 py-2 !rounded-lg bg-[#6588A6] hover:bg-[#4A6480] text-white
                     font-semibold text-sm transition-all disabled:opacity-40 flex items-center gap-2">
              <i class="pi pi-calculator"></i>
              <span>Calcular KM</span>
              <i class="pi pi-spin pi-spinner" *ngIf="calculandoKM && this.selectedMovimiento.clv_eliminar==0"></i>
            </button>
          </div>

          <!-- Kilómetros resultado -->
          <div class="flex items-center justify-between bg-slate-50 rounded-lg px-4 py-3 border border-slate-200">
            <span class="text-sm font-semibold text-slate-500">
              <i class="pi pi-directions text-[#82B0D9] mr-1"></i>
              Kilómetros (calculado por Maps):
            </span>
            <span class="text-base font-bold"
              [ngClass]="viajeVacioForm.get('num_kilometros')?.value !== null ? 'text-[#6588A6]' : 'text-slate-300'">
              {{ viajeVacioForm.get('num_kilometros')?.value !== null ? (viajeVacioForm.get('num_kilometros')?.value | number: '1.0-0') + ' km' : '###' }}
            </span>
          </div>

          <!-- Divider + título totales -->
          <div class="flex items-center gap-3 pt-1">
            <div class="w-1 h-5 rounded-full bg-[#82B0D9]"></div>
            <span class="text-xs font-bold text-[#6588A6] uppercase tracking-wider">
              Total a pagar (calculado)
            </span>
          </div>

          <!-- Costo por KM / Sueldo / Viáticos — inputs deshabilitados -->
          <div class="bg-slate-50 rounded-xl p-4 space-y-3 border border-slate-100">
            <div class="flex flex-col gap-1">
                <label class="text-sm font-semibold text-slate-600">Costo por KM</label>
                <input type="number" formControlName="costo_por_km" readonly placeholder="$0.00"
                class="w-full rounded-lg border border-slate-200 bg-slate-100 px-3 py-2 text-sm
                        text-slate-500 cursor-not-allowed text-right font-semibold">
            </div>

            <div class="flex flex-col gap-1">
                <label class="text-sm font-semibold text-slate-600">Sueldo</label>
                <input type="number" formControlName="sueldo" readonly placeholder="$0.00"
                class="w-full rounded-lg border border-slate-200 bg-slate-100 px-3 py-2 text-sm
                        text-slate-500 cursor-not-allowed text-right font-semibold">
            </div>

            <div class="flex flex-col gap-1">
                <label class="text-sm font-semibold text-slate-600">Viáticos por Evento</label>
                <input type="number" formControlName="viaticos_por_evento" readonly placeholder="$0.00"
                class="w-full rounded-lg border border-slate-200 bg-slate-100 px-3 py-2 text-sm
                        text-slate-500 cursor-not-allowed text-right font-semibold">
            </div>
            <div class="flex flex-col gap-1">
                <label class="text-[#6588A6] text-xs font-semibold uppercase tracking-wider flex items-center gap-1">
                <i class="pi pi-calendar text-sm text-[#6588A6]"></i> Fecha de Pago
                </label>
                <input
                formControlName="fec_pago"
                type="date"
                class="bg-white/15 border border-white/30 text-[#6588A6] rounded-lg px-3 py-2 text-sm
                        placeholder-indigo-200 focus:outline-none focus:ring-2 focus:ring-[#C4D9EC]/60
                        [color-scheme:dark] min-w-[160px]"
                pTooltip="Seleccione o teclee fecha"
                
                tooltipPosition="left">
            </div>

            </div>

          <!-- Nota de regla de negocio -->
          <div class="flex items-start gap-2 bg-[#EBF2F8] rounded-lg p-3">
            <i class="pi pi-info-circle text-[#82B0D9] mt-0.5 flex-shrink-0 text-sm"></i>
            <div class="text-xs text-[#6588A6] space-y-1">
              <p class="font-semibold">Pago:</p>
              <p>Mayor a 500 km: Costo por KM + Sueldo Base + Viáticos.</p>
              <p>Menor o igual a 500 km: Costo por KM.</p>
              <p class="text-[#B85C5C] font-semibold flex items-center gap-1 pt-1">
                <i class="pi pi-exclamation-triangle text-xs"></i>
                Solo se permite guardar si km &gt; 0
              </p>
            </div>
          </div>

        </div>
      </form>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="flex items-center justify-between w-full">

      <button pButton pRipple label="Cerrar" icon="pi pi-times"
        class="!bg-[#EBF2F8] !text-[#4A6480] !border-0 !rounded-lg hover:!bg-[#C4D9EC] !transition-all"
        (click)="cancelarModalViajeVacio()">
      </button>

      <button type="button" pButton pRipple
        (click)="guardarViajeVacio()"
        [disabled]="!this.viajeVacioForm.valid||(this.btnHabilitarViajeVacio && this.selectedMovimiento.clv_eliminar==1)
        && (!(this.viajeVacioForm.get('num_kilometros')!.value <= 0)
        ||this.viajeVacioForm.get('num_kilometros')!.value === null)"
        pTooltip="Solo disponible si km > 0" tooltipPosition="top"
        class="!bg-[#4A7C6F] !border-0 !rounded-lg !text-white !font-semibold
               !px-5 !py-2 hover:!bg-[#3A6358] !transition-all !shadow-sm
               disabled:!opacity-40 flex items-center gap-2">
        <i class="pi pi-save"></i>
        <span>Guardar Viaje Vacío</span>
        <i class="pi pi-spin pi-spinner" *ngIf="btnHabilitarViajeVacio && this.selectedMovimiento.clv_eliminar==0"></i>
      </button>

    </div>
  </ng-template>

</p-dialog>
  
  <!-- ════════════════════════════════════════════════════
       MODAL — REPORTES
  ════════════════════════════════════════════════════ -->
  <p-dialog [resizable]="false" [draggable]="false"
    [(visible)]="dbsReportes"
    [style]="{ width: '60vw', height: '620px' }"
    [transitionOptions]="'0ms'"
    styleClass="erp-dialog"
    (onHide)="cancelarModalReportes()">

    <ng-template pTemplate="header">
      <div class="flex items-center gap-3">
        <div class="w-9 h-9 rounded-lg bg-[#EAF3EF] flex items-center justify-center">
          <i class="pi pi-chart-bar text-[#4A7C6F]"></i>
        </div>
        <div>
          <h3 class="text-slate-800 font-bold text-white">Reportes</h3>
          <p class="text-slate-400 text-xs text-white font-normal">Generación y exportación</p>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="content">
      <div class="p-4 md:p-6 space-y-4">

        <!-- Reporte 1 -->
        <div class="bg-slate-50 rounded-xl p-5">
          <h4 class="text-sm font-bold text-[#2E4357] mb-4 flex items-center gap-2">
            <i class="pi pi-file-excel text-[#4A7C6F]"></i>
            Movimientos de Operación (Gestión de Ruta)
          </h4>
          <div class="grid grid-cols-1 sm:grid-cols-3 gap-4 items-end">
            <div class="space-y-1">
              <label class="text-xs font-semibold text-slate-500 uppercase">Fecha Inicio</label>
              <input type="date" [(ngModel)]="fecha_inicio_r1"
                pTooltip="Fecha de inicio" tooltipPosition="top"
                class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm
                       focus:outline-none focus:ring-2 focus:ring-indigo-300 transition-all">
            </div>
            <div class="space-y-1">
              <label class="text-xs font-semibold text-slate-500 uppercase">Fecha Fin</label>
              <input type="date" [(ngModel)]="fecha_fin_r1"
                pTooltip="Fecha de fin" tooltipPosition="top"
                class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm
                       focus:outline-none focus:ring-2 focus:ring-indigo-300 transition-all">
            </div>
            <div>
              <button type="button" 
                [disabled]="btngenerandoReporte"
                class="w-full px-4 py-2 rounded-lg bg-[#4A7C6F] hover:bg-[#3A6358] text-white
                       font-semibold text-sm transition-all disabled:opacity-40 flex items-center justify-center gap-2">
                <i class="pi pi-file-export"></i> Exportar
              </button>
            </div>
          </div>
          <div class="flex justify-center mt-3">
            <i class="pi pi-spin pi-spinner text-[#4A7C6F]" *ngIf="btngenerandoReporte"></i>
          </div>
        </div>

        <!-- Reporte 2 -->
        <div class="bg-slate-50 rounded-xl p-5">
          <div class="flex items-center justify-between">
            <h4 class="text-sm font-bold text-[#2E4357] flex items-center gap-2">
              <i class="pi pi-file-excel text-[#4A7C6F]"></i>
              Reporte 2
            </h4>
            <button type="button" 
              class="px-4 py-2 rounded-lg bg-[#4A7C6F] hover:bg-[#3A6358] text-white
                     font-semibold text-sm transition-all flex items-center gap-2">
              <i class="pi pi-file-export"></i> Exportar
            </button>
          </div>
        </div>

      </div>
    </ng-template>

    <ng-template pTemplate="footer">
      <button pButton pRipple label="Cerrar" icon="pi pi-times"
        class="!bg-[#EBF2F8] !text-[#4A6480] !border-0 !rounded-lg hover:!bg-[#C4D9EC] !transition-all"
        (click)="cancelarModalReportes()">
      </button>
    </ng-template>
  </p-dialog>

</div>
<!-- /PÁGINA PRINCIPAL -->